<template>
  <Dialog
    v-model="dialog"
    :buttons="dialogButtons"
    :title="dialogTitle"
    :header-type="dialogHeaderType"
    :loading="dialogLoading"
    :left-header-icon="dialogLeftHeaderIcon"
  >
    <template #leftIcon>
      <CountDownIcon
        v-if="verificationResult === 'error_timeout'"
        :value="100 / resendSMSTimeDefaultValue"
      />
    </template>
    <template #text>
      <PhoneVerification @close="dialog = false" />
    </template>
  </Dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import phoneVerification from '@/mixins/phoneVerification';
import Dialog from '@/components/Atoms/Dialog';
import CountDownIcon from '@/components/Atoms/CountDownIcon';
import PhoneVerification from '@/components/Molecules/PhoneVerification';

export default {
  name: 'PhoneVerificationDialog',
  components: { PhoneVerification, CountDownIcon, Dialog },
  mixins: [phoneVerification],
  computed: {
    dialog: {
      get() {
        return this.$store.state.profile.dashboard.dialog === 'phone-verification';
      },
      set(value) {
        this.$store.commit('profile/dashboard/setDialog', value);
      }
    },
    ...mapGetters({
      dialogButtons: 'profile/phoneVerification/dialogButtons',
      dialogTitle: 'profile/phoneVerification/dialogTitle',
      dialogLeftHeaderIcon: 'profile/phoneVerification/dialogLeftHeaderIcon',
      dialogHeaderType: 'profile/phoneVerification/dialogHeaderType',
      verificationResult: 'profile/phoneVerification/verificationResult',
      dialogLoading: 'profile/phoneVerification/dialogLoading'
    })
  },
  watch: {
    async dialog(newValue) {
      if (newValue) {
        await this.resendPhoneVerification();
      }
    }
  }
};
</script>
